import { Layout, Row } from 'antd'
import { useTranslation } from 'react-i18next'
import i18n from '../i18n'
import type { FC } from 'react'

export const Footer: FC = () => {
  const { t } = useTranslation()
  const showLinks =
    i18n.exists('Footer.Privacy.link') ||
    i18n.exists('Footer.Terms.link') ||
    i18n.exists('Footer.Imprint.link')

  return (
    <Layout.Footer>
      {showLinks && (
        <Row className="links">
          <ul>
            {i18n.exists('Footer.Privacy.link') && (
              <li>
                <a href={t('Footer.Privacy.link')}>{t('Footer.Privacy')}</a>
              </li>
            )}
            {i18n.exists('Footer.Terms.link') && (
              <li>
                <a href={t('Footer.Terms.link')}>{t('Footer.Terms')}</a>
              </li>
            )}
            {i18n.exists('Footer.Imprint.link') && (
              <li>
                <a href={t('Footer.Imprint.link')}>{t('Footer.Imprint')}</a>
              </li>
            )}
            {i18n.exists('Footer.Jobs.link') && (
              <li>
                <a href={t('Footer.Jobs.link')}>{t('Footer.Jobs')}</a>
              </li>
            )}
          </ul>
        </Row>
      )}
    </Layout.Footer>
  )
}
